var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"file_download",on:{"click":_vm.download}},[_c('i',{staticClass:"iconbht",class:_vm.iconClass,style:(_vm.iconStyle)}),_c('p',{staticClass:"file_name"},[_vm._v(" "+_vm._s(_vm.file.fileName || '无文件')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }